import { MwLoadOptions } from 'app/models/load-options.model';
import { TerminalTransactionApiModel } from 'app/models/terminal-transaction-api.model';
import { createAction, props } from '@ngrx/store';
import { MwPayloadModel } from 'app/models/payload.model';

export const loadTerminalTransactions = createAction(
  '[TerminalTransactions] Load',
  props<{ loadOptions?: MwLoadOptions }>()
);

export const loadTerminalTransactionsSuccess = createAction(
  '[TerminalTransactions] Load Successful',
  props<{ response: MwPayloadModel<TerminalTransactionApiModel[]> }>()
);

export const loadTerminalTransactionsFailure = createAction(
  '[TerminalTransactions] Load Failure',
  props<{ error: any }>()
);

export const updateTerminalTransaction = createAction(
  '[TerminalTransactions] Update',
  props<{ terminalTransaction: TerminalTransactionApiModel }>()
);

export const updateTerminalTransactionSuccess = createAction(
  '[TerminalTransactions] Update Successful',
  props<{ terminalTransaction: TerminalTransactionApiModel }>()
);

export const updateTerminalTransactionFailure = createAction(
  '[TerminalTransactions] Update Failure',
  props<{ error: any }>()
);
